import { useQuery } from '@apollo/client';
import { useAuthStore } from '@/store/useAuthStore';
import { GetUserResponse } from '@/api/types/user.types';
import { GET_USER } from '@/api/queries/user.queries';

export function useCurrentUser() {
  const {
    shop,
    isShop,
    isActiveShop,
    legacyId: userLegacyId,
    name: userName,
    email: userEmail,
    emailConfirmed: userEmailConfirmed,
    authenticationPhone: userAuthenticationPhone,
    features: userFeatures,
  } = useAuthStore(state => state.userInfo);

  const {
    name: shopName,
    logo,
    isPendingInvoice,
    segment: shopSegment,
  } = shop ?? {};

  const { data: userDetailedInfo, loading } = useQuery<GetUserResponse>(
    GET_USER,
    { errorPolicy: 'all' }
  );

  const {
    legacyId,
    name,
    email,
    emailConfirmed,
    authenticationPhone,
    createdAt,
    photo,
    walletBalance,
    isAppleGooglePayEnabled,
    paymentMethods,
    features,
  } = userDetailedInfo?.currentUser ?? {};

  return {
    loading,
    isShop: Boolean(isShop),
    isActiveShop: Boolean(isActiveShop),
    shop: shop
      ? {
          name: shopName,
          logo: logo?.url,
          segment: shopSegment,
          isPendingInvoice,
        }
      : null,
    user: {
      id: legacyId ?? userLegacyId,
      name: name ?? userName,
      email: email ?? userEmail,
      emailConfirmed: emailConfirmed ?? userEmailConfirmed,
      phone: authenticationPhone ?? userAuthenticationPhone,
      createdAt,
      avatarUrl: photo?.url,
      walletBalance,
      isAppleGooglePayEnabled,
      paymentMethods,
      features: features ?? userFeatures,
    },
  };
}
